{
  "actions": "Aktionen",
  "hideButtonLabel": "Weniger zeigen",
  "noTags": "Keine",
  "showAllButtonLabel": "Alle anzeigen ({tagCount, number})"
}
